module.exports = __webpack_public_path__ + "img/00043.1a6f2eda.webp";